module.exports = __webpack_public_path__ + "assets/img/principleImgEN.4e5ec995.png";